<template>
  <div>
    <div class="gameplay_title_container">
      <div class="gameplay_title">
        {{ getTranslations.attention_color_question_first }}<br>{{ getTranslations.attention_color_question_second }}
      </div>
    </div>

    <div class="gameplay_game_box_list gameplay_tap_box att4">
      <div class="gameplay_btns_col">
        <div class="content_box first">
          <div class="show_box">{{ gameInfo.descColorText }}</div>
        </div>
        <div class="content_box second">
          <div :class="['show_box', gameInfo.cssClass]">{{ gameInfo.colorQuestion }}</div>
        </div>
      </div>
      <div class="gameplay_divider"></div>

      <div class="gameplay_btns_row">
        <button type="button" :disabled="buttonPushed" class="gameplay_btn select_answer" @click.prevent="sendAnswer(0)"
                ref="yesButton">{{ getTranslations.attention_color_yes_answer }}</button>
        <button type="button" :disabled="buttonPushed" class="gameplay_btn select_answer" ref="noButton" @click.prevent="sendAnswer(1)">{{ getTranslations.attention_color_no_answer }}</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off", no-nested-ternary: "off" */
import { mapState, mapGetters } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import { equalHeightAndWidth, gameplayFooter } from '@/common/jQuery';


export default {
  name: 'attentionColor',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  data() {
    return {
      gameInfo: null, // NEW
      buttonPushed: false,
    };
  },
  created() {
    this.initGameData();
  },
  mounted() {
    equalHeightAndWidth();
    this.$nextTick(() => { this.loadImage(); });
  },
  methods: {
    loadImage() {
      gameplayFooter();
    },
    initGameData() {
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
    },
    getPartOfAnswers(part) {
      if (part === 1) {
        return this.gameInfo.questions.slice(0, this.gameInfo.questions.length);
      }
      return null;
    },
    calculateRefIndex(indexToBack) {
      return (indexToBack === 0) ? this.$refs[1][0] : (indexToBack === 1) ? this.$refs[2][0] : (indexToBack === 2) ? this.$refs[1][1] : this.$refs[2][1];
    },
    sendAnswer(index) {
      const indexToBack = index;
      if (indexToBack === 0) {
        if (this.$refs.yesButton.classList.contains('correct')) {
          this.$refs.yesButton.classList.remove('correct');
        } else {
          this.$refs.yesButton.classList.remove('rejected');
        }
      } else if (indexToBack === 1) {
        if (this.$refs.noButton.classList.contains('correct')) {
          this.$refs.noButton.classList.remove('correct');
        } else {
          this.$refs.noButton.classList.remove('rejected');
        }
      }
      let isCorrectAnswer = false;
      if (this.buttonPushed) {
        console.log('--> User 2 times. Wait for Answer....');
      } else {
        this.buttonPushed = true;
        this.$axios({
          url: `api/sendAnswerBrainiac?gameId=${this.gameID}&miniGameId=${this.gameInfo.id}&answerIndex=${indexToBack}`,
          method: 'GET',
          headers: {
            Authorization: this.jwtInVuex,
          },
        }).then((response) => {
          const responseData = response.data.data;
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            if (responseData.status === 'WRONG_ANSWER') {
              console.log('index ', indexToBack);
              if (indexToBack === 0) {
                this.$refs.yesButton.classList.add('rejected');
                this.$refs.yesButton.classList.add('gameplay_btn_false');
              } else {
                this.$refs.noButton.classList.add('rejected');
                this.$refs.noButton.classList.add('gameplay_btn_false');
              }
            } else if (responseData.status === 'CORRECT_ANSWER') {
              isCorrectAnswer = true;
              console.log('index ', indexToBack);
              if (indexToBack === 0) {
                this.$refs.yesButton.classList.add('correct');
                this.$refs.yesButton.classList.add('gameplay_btn_correct');
              } else {
                this.$refs.noButton.classList.add('correct');
                this.$refs.noButton.classList.add('gameplay_btn_correct');
              }
            }
          }
          setTimeout(() => {
            this.normalTransition = true;
            this.storeBrainiacGameData(isCorrectAnswer);
          }, 1500);
        }).catch((error) => {
          console.log(`Invoking api/sendAnswer failed with the following error: ${error}`);
        });
      }
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/attention/AttentionColor.vue